import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { updateSubAreasPagination } from '../../store/actions/sub_area/sub_area_action';
import { Typography, Button, Container, Grid, makeStyles } from '@material-ui/core';
import SubAreasTable from './sub_areas_table';
import SearchComponent from '../ui_components/search';
import { REACT_ROUTES } from '../../constants/react_routes';
import history from '../../services/history';

const useStyles = makeStyles((theme) => ({
	container: {
		padding: theme.spacing(3, 2)
	},
    centerAlign: {
        textAlign: 'center'
    }
}));

const SubAreaList = ({ subAreas }) => {
    const { container, centerAlign } = useStyles();
    const [search, setSearch] = useState('');
    const dispatch = useDispatch();

    const { filters } = subAreas;

    useEffect(() => {
        if (filters?.search) {
            setSearch(filters.search);
        }
    }, []);

    const handleSearch = (e) => {
        const search = e.target.value;
        setSearch(search);
        dispatch(updateSubAreasPagination({...subAreas, page: 0, filters: { ...filters, search }}))
    }

    const handleAddSubAreaClick = () => {
        history.push(REACT_ROUTES.SUB_AREA);
    }

    return (
        <Container className={container}>
            <Typography variant="h4" align="center" gutterBottom>
                Dijagnoze
            </Typography>
            <Grid container justify="center" spacing={1}>
                <SearchComponent value={search} handleSearch={handleSearch} />
                <Grid item xs={8} className={centerAlign}>
                    <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        onClick={handleAddSubAreaClick}
                    >
                        Kreirajte novu dijagnozu
                    </Button>
                </Grid>
            </Grid>
            <SubAreasTable />
        </Container>
    )
}

SubAreaList.propTypes = {
    subAreas: PropTypes.object
}

const mapStateToProps = (state) => ({
    subAreas: state.subAreas
});

export default connect(mapStateToProps)(SubAreaList);
